module.exports = __webpack_public_path__ + "static/media/loading.b98d9cb9.gif";